export default __webpack_public_path__ + "tab3_mobile37edd6.mp4";